import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './locales/en/ui.json';
import fr from './locales/fr/ui.json';

// English + French, like the add-in: every string in BOTH files, English the default (never picked from the
// browser locale; the header toggle switches).
void i18n.use(initReactI18next).init({
  resources: { en: { translation: en }, fr: { translation: fr } },
  lng: 'en',
  fallbackLng: 'en',
  interpolation: { escapeValue: false },
});

export default i18n;
